module.exports = __webpack_public_path__ + "static/img/lectureThree.c66c70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lectureThree.png
// module id = 3o6Z
// module chunks = 1